var DealSavingsType;
(function (DealSavingsType) {
    DealSavingsType["SPECIAL_RATES"] = "specialRates";
    DealSavingsType["CURRENCY"] = "currency";
    DealSavingsType["PERCENTAGE"] = "percentage";
    DealSavingsType["FREE"] = "free";
})(DealSavingsType || (DealSavingsType = {}));
export default DealSavingsType;
